<div class="gov-card">
  <div
    class="gov-card__header">
    {{ edit ? 'Edycja ' : 'Dodanie ' }}
    {{ treeItemFormType === 'tree' ? 'drzewa' : 'krzewu' }}
  </div>
  <div class="gov-card__body">
    <form *ngIf="form as form" novalidate autocomplete="off" [formGroup]="form">
      <fieldset>
        <div class="row">
          <div class="col-md-4">
            <div class='form-group' *ngIf='"district" as controlName'>
              <label [for]='controlName'>Obręb *</label>
              <select
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [id]='controlName'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option *ngFor='let item of form.obrebList()' [value]='item?.name'>
                  {{ item?.name }}
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"registryNumber" as controlName'>
              <label [for]='controlName'>
                Działka numer
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Działka numer'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-md-6">
            <div class='form-group' *ngIf='"landDesignation" as controlName'>
              <label [for]='controlName'>
                Przeznaczenie terenu *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu do czego przeznaczony teren'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class='form-group' *ngIf='"species" as controlName'>
              <label [for]='controlName'>
                Nazwa gatunku *
              </label>
              <select
                (change)="form.calcRemovalFee(treeItemFormType)"
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [id]='controlName'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @if (treeItemFormType === "tree") {
                  <option *ngFor='let item of form.treeSpecies()'
                          [value]='item?.gatunek_drzewa'>
                    {{ item?.gatunek_drzewa | capitalizeFirstLetter }}
                  </option>
                }
                @if (treeItemFormType === "shrub") {
                  <option *ngFor='let item of form.shrubSpecies()'
                          [value]='item?.gatunek_krzew'>
                    {{ item?.gatunek_krzew | capitalizeFirstLetter }}
                  </option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          @if (form.trunkCircumference130) {
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"trunkCircumference130" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia krzewu (m²) *
                </label>
                <input
                  (change)="form.calcRemovalFee(treeItemFormType)"
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu powierzchnie'
                  mask="0*"
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"removalFee" as controlName'>
              <label [for]='controlName'>
                Wysokość opłaty za usunięcie *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu wysokość opłaty'
                mask="separator.2"
                decimalMarker=","
                [dropSpecialCharacters]="false"
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        @if (treeItemFormType === 'tree') {
          <app-trunk-circumference-crud
            (itemChange)="form.calcRemovalFee(treeItemFormType)"
            [form]="form.trunkCircumference130Form">
          </app-trunk-circumference-crud>
        }
      </fieldset>
      <fieldset>
        <legend>
          Przyczyny/a usunięcia:
        </legend>
        <br>
        <div class="row">
          <div class="col-md-6">
            @if (form.removalReason.unchecked && form.removalReason.touched) {
              <app-alert
                [closable]="false"
                type="danger">
                Zaznacz odpowidnie!
                <strong><small>(min. 1 z wymienionych)</small></strong>
              </app-alert>
              <br>
            }
          </div>
        </div>
        <div class="row">
          <div class='col-md-6' [formGroup]="form.removalReason">
            <ul class="pt-1">
              @for (item of form.removalReason.removalReasons(); track item.id) {
                <li>
                  <div class='form-group' *ngIf='(item.code || "") as controlName'>
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        (change)="form.removalReasonChange()"
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        {{ item?.name || '' }}
                      </label>
                    </div>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </li>
              }
            </ul>
          </div>
          @if (form.otherRemovalReason) {
            <div class="col-md-6">
              <div class='form-group' *ngIf='"otherRemovalReason" as controlName'>
                <label [for]='controlName'>
                  Inna przyczyna *
                </label>
                <textarea
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu przyczynę usunięcia'
                  type='text'>
                </textarea>
                <app-validation-errors [showTextLength]="true" [maxTextLength]="255" [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          <div class="col-12">
            <div class='form-group' *ngIf='"removalJustification" as controlName'>
              <label [for]='controlName'>
                Uzasadnienie usunięcia *
              </label>
              <textarea
                rows="4"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu uzasadnienie usunięcia'
                type='text'>
                </textarea>
              <app-validation-errors [showTextLength]="true" [maxTextLength]="5000" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          <i class="fa fa-trash" aria-hidden="true"></i>Anuluj
        </button>
        <button type="button" class="btn btn-secondary" (click)="onSubmit()">
          @if (!edit) {
            <i class="fa fa-plus" aria-hidden="true"></i>Dołącz do wniosku
          } @else {
            <i class="fa fa-save" aria-hidden="true"></i>Zaktualizuj dane
          }
        </button>
      </div>
    </form>
  </div>
</div>
